import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../../components/ui";

export default function MailboxSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Mailbox</CardTitle>
        <CardDescription>Manage mailbox accounts and access rules.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">
          Mailbox settings module in progress.
        </div>
      </CardContent>
    </Card>
  );
}